import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';

import Segment from '../../../../components/Segment';
import Spinner from '../../../../components/Spinner/';
import Logo from '../../components/Logo';
import Background from '../../components/Background';
import Card from '../../components/Card';

import DogeImage from '../../assets/doge.jpg';
import MaryImage from '../../assets/mary.jpg';
import CharlesImage from '../../assets/charles.jpg';
import LeoImage from '../../assets/leo.jpg';
import BeccaImage from '../../assets/becca.jpg';

import './style.scss';

const segment = new Segment();

const MatchStudentAdvisor = gql`
  query {
    matchStudentAdvisor {
      id
      email
      first_name
      last_name
      photo
      linkedin_username
      industries {
        id
        name
      }
      advisor_info {
        wistia
        position
        company
        degree
        university
      }
    }
  }
`;

const TESTIMONIALS = [
  {
    imageSrc: MaryImage,
    tagline:
      'Join students like Mary who landed 3 internships as a freshman, thanks to career advisors from Paragon One.',
    quote: 'I am lucky to call some of the advisors my friends.',
  },
  {
    imageSrc: CharlesImage,
    tagline:
      'Join students like Charles who landed a software engineering job at hedge fund Bridgewater through an advisor referral.',
    quote:
      'This was not an experience I could get by simply doing mock interviews with friends.',
  },
  {
    imageSrc: LeoImage,
    tagline:
      'Join students like Leo who landed an internship in management consulting at PwC and eventually a full time offer.',
    quote: 'My advisors helped me grow faster.',
  },
  {
    imageSrc: BeccaImage,
    tagline:
      'Join students like Becca who landed a sales & trading internship at Goldman Sachs as a college sophomore.',
    quote: 'The Paragon One network is incredibly valuable.',
  },
];

class Loading extends React.Component {
  state = {
    advisors: [],
    isReady: false,
    testimonialIndex: _.random(0, 3),
  };

  componentWillMount() {
    const { isAuthenticated } = this.props;
    if (!isAuthenticated) {
      this.props.router.push({
        pathname: '/assessment',
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    const didChangeLoading =
      this.props.MatchStudentAdvisor.loading &&
      !nextProps.MatchStudentAdvisor.loading;
    if (didChangeLoading) {
      const advisors = nextProps.MatchStudentAdvisor.matchStudentAdvisor;
      console.log('ADVISORS', advisors);

      if (!advisors || !advisors.length) {
        // TODO: if no results, redirect to fallback confirmation screen
        this.props.router.push({
          pathname: '/assessment/fallback',
        });
      } else {
        this.setState({
          advisors,
          isReady: true,
        });
      }
    }
  }

  handleCTA = () => {
    const { location: { state } } = this.props;

    segment.track('step5_clicked_advisors');

    this.props.router.push({
      pathname: '/assessment/advisors',
      state: {
        ...state,
        advisors: this.state.advisors,
      },
    });
  };

  getHeading() {
    return (
      <div className="loading__heading">Sit tight! Loading your matches…</div>
    );
  }

  getSubheading() {
    return (
      <div className="loading__subheading">
        In the meantime, here’s what our students have to say about us:
      </div>
    );
  }

  getTestimonials() {
    const testimonial = TESTIMONIALS[this.state.testimonialIndex];
    return (
      <Card>
        <div className="loading__testimonials">
          <div className="loading__mobileTitle">What our students say</div>
          <div className="loading__image">
            <img src={testimonial.imageSrc || DogeImage} />
          </div>
          <div className="loading__tagline">{testimonial.tagline}</div>
          <div className="loading__quote">
            <i>"{testimonial.quote}"</i>
          </div>
        </div>
      </Card>
    );
  }

  getCTA() {
    const { isReady } = this.state;

    const buttonComponent = !isReady ? (
      <Spinner className="spinner--white" />
    ) : (
      'Your advisors are ready!'
    );

    return (
      <div className="loading__cta">
        <button
          className="btn btn-paragon-one"
          onClick={this.handleCTA}
          disabled={!isReady}
        >
          {buttonComponent}
        </button>
      </div>
    );
  }

  render() {
    return (
      <div>
        <Background />
        <Logo />
        <div className="assessment__wrapper--narrow">
          {this.getHeading()}
          {this.getSubheading()}
          {this.getTestimonials()}
          {this.getCTA()}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    authedUser: _.get(state, 'auth.User'),
    isAuthenticated: !!_.get(state, 'auth.sub'),
  };
};

const mapDispatchToProps = {};

export default store => ({
  path: 'loading',
  component: connect(mapStateToProps, mapDispatchToProps)(
    compose(
      graphql(MatchStudentAdvisor, {
        name: 'MatchStudentAdvisor',
      })(Loading),
    ),
  ),
});



// WEBPACK FOOTER //
// ./src/routes/assessment/routes/Loading/index.js